<template>
    <v-card color="grey-f7" flat>
        <v-card-text class="pa-4 txt txt--sm txt--dark font-size-14 text-center">
            <span> {{ message?.message }} </span>
        </v-card-text>
    </v-card>
</template>

<script>
import { initLectureChatMessage } from "@/store/lecture/chat/chat.inits";

export default {
    props: {
        message: { type: Object, default: initLectureChatMessage },
    },
};
</script>

<style></style>
